<div class="intuitive-order-layout">
	<div class="intuitive-order-layout__procedure-button">
		<ng-content select="[slot=procedure-button]" />
	</div>

	<tlk-card class="intuitive-order-layout__inline-card" [padding]="0" data-testid="order-send-to">
		<ng-content select="[slot=send-to]" />
	</tlk-card>

	<tlk-card class="intuitive-order-layout__inline-card intuitive-order-layout__inline-card--due-date" [padding]="0">
		<ng-content select="[slot=due-date]" />
	</tlk-card>
</div>
